import React from 'react';
import { Phone, MapPin, Mail } from 'lucide-react';
import { OrderButton } from './OrderButton';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-4 flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_brand-consultation/artifacts/5p8whwdm_avid-race.png" 
                alt="Avid Branding Logo"
                className="h-10 w-auto mr-3"
              />
              <div>
                <h3 className="text-xl font-bold text-white">Avid Branding</h3>
                <p className="text-gray-400">A division of DA-12 Corp</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Custom printed and embroidered apparel for small businesses. 
              Quality products with no minimum orders, helping you build 
              your brand presence one item at a time.
            </p>
            <div className="flex items-center space-x-4">
              <div className="bg-blue-600 px-4 py-2 rounded-lg">
                <span className="font-semibold">No Minimums</span>
              </div>
              <div className="bg-teal-600 px-4 py-2 rounded-lg">
                <span className="font-semibold">Free Samples</span>
              </div>
            </div>

            {/* Order CTA */}
            <div className="mt-6">
              <OrderButton
                label="Start Your Order"
                testid="footer-start-order-button"
                className="px-10 py-5 text-lg"
              />
            </div>
            
            {/* Newsletter Signup Button */}
            <div className="mt-6">
              <button
                onClick={() => window.open('https://preview.mailerlite.io/forms/1300492/164127746890400924/share', '_blank')}
                className="bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200 transform hover:scale-105"
              >
                📬 Subscribe to our mailout
              </button>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-blue-400" />
                <p className="text-white font-semibold">communications@da-12.com</p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-blue-400" />
                <div>
                  <p className="text-white font-semibold">519-938-8959</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-blue-400 mt-1" />
                <div>
                  <p className="text-gray-300">4-246372 Hockley Rd</p>
                  <p className="text-gray-300">Orangeville, ON</p>
                </div>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Custom T-Shirts</li>
              <li>Embroidered Hoodies</li>
              <li>Custom Hats</li>
              <li>Promotional Mugs</li>
              <li>Logo Design</li>
              <li>Brand Consultation</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <div className="text-gray-400 text-sm">
              © {currentYear} Avid Branding - A division of DA-12 Corp. All rights reserved.
            </div>
            <div className="text-gray-400 text-sm">
              Proudly serving Orangeville and surrounding areas
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};